import React, { Fragment } from 'react';

import {
  linksSubscribe,
  linksAccount,
  linksContact,
  linksSocial,
  linksMore,
} from '../../constants/constants-footer-links';

/**
 * Site footer.
 * @returns {React.component} The Footer to render.
 */
export default function Footer() {
  const renderLinks = (arr) => {
    const links = arr.map((link, index) => {
      return (
          <li key={index} className="site-footer__list-item">
            <a href={link.link}>{link.label}</a>
          </li>
      );
    });
    return links;
  }

  const linkContainer = (heading, func) => {
    return (
      <Fragment>
        <p className="section-heading">{heading}</p>
        <ul className="site-footer__list">
          {func}
        </ul>
      </Fragment>
    );
  }

  return (
    <footer className="site-footer contain">
      <div className="site-footer__list-container">
          {linkContainer("Subscribe now", renderLinks(linksSubscribe))}
          {linkContainer("My account", renderLinks(linksAccount))}
      </div>
      <div className="site-footer__list-container">
        {linkContainer("Contact", renderLinks(linksContact))}
      </div>
      <div className="site-footer__list-container">
        {linkContainer("Social", renderLinks(linksSocial))}
      </div>
      <div className="site-footer__list-container">
        {linkContainer("More", renderLinks(linksMore))}
      </div>
      <p className="site-footer__copyright">
        © {(new Date()).getFullYear()} Boston Globe Media Partners, LLC
      </p>
    </footer>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Footer/Footer.js